var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ac65f4e71778e6e3521c16f7738521a84bd37348"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["medwind@mvr-studio"]={id:"ac65f4e71778e6e3521c16f7738521a84bd37348"};
      